import { Helmet } from 'react-helmet-async'

export default function SEO({ title, description, keywords, path = '' }) {
  const base = 'https://nexcoresolutions.com'
  const fullTitle = title ? `${title} | NexCore Solutions` : 'NexCore Solutions – Enterprise Product Development'
  const defaultDesc = 'NexCore Solutions builds enterprise-grade software: HCM, Takeaway Systems, Account Management, Textile ERP, and Manufacturing Inventory solutions.'

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={`${base}${path}`} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:url" content={`${base}${path}`} />
      <meta property="og:site_name" content="NexCore Solutions" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
    </Helmet>
  )
}
